/* --------------------------------------------------------------------------------------
   printModule.service.js
   Copyright © 2019 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export class printModuleService {
  /* @ngInject */
  constructor(xeroxEIPParameters, apiClientService, commonService, $translate) {
    this.xeroxEIPParameters = xeroxEIPParameters;
    this.apiClientService = apiClientService;
    this.commonService = commonService;
    this.$translate = $translate;
  }
  setOptions() {
    this.twoSidedPrintOptions = this.xeroxEIPParameters.sides.filter((side) =>
      side.scope.includes("scan")
    );
    this.outputColorOptions = this.xeroxEIPParameters.printColorModes;
    this.stapling = false;
    this.copies = 1;
  }

  async setDefaults() {
    this.twoSidedPrint = this.twoSidedPrintOptions[0].key;
    this.twoSidedPrintText = await this.$translate(
      this.twoSidedPrintOptions[0].translationKey
    );

    this.outputColor = this.outputColorOptions[0].key;
    this.outputColorText = await this.$translate(
      this.outputColorOptions[0].translationKey
    );
  }

  getPrintTicket(guid, documentId) {
    const postdata = { DocumentID: documentId };
    return this.apiClientService.post("/print/ticket/" + guid, postdata);
  }

  async getPrintUrl(printTicketGuid) {
    return (
      this.apiClientService.getApiUrl() +
      "/print/p?printTicket=" +
      printTicketGuid
    );
  }

  getPrintPreview(tokenGuid) {
    return this.apiClientService.get("/print/preview/" + tokenGuid);
  }
}



// WEBPACK FOOTER //
// ./src/app/print/services/printModule.service.js